import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { SignInGoogle } from '../SignInGoogle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button } from'@material-ui/core';

const styles = theme => ({
  margin: {
    margin: theme.spacing.unit,
  },
});

const validate = values => {
  const errors = {};
  const requiredFields = [
    'email',
    'password'
  ];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }
  return errors
};

const renderEmailField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <Grid container spacing={8} alignItems="flex-end">
    <Grid item xs={1} md={1} sm={1} lg={1} xl={1}>
      <img src="../../../../../assets/images/email-icon.png"/>
    </Grid>
    <Grid item xs={11} md={11} sm={11} lg={11} xl={11}>
      <TextField
        label={label}
        type="email"
        {...input}
        {...custom}
        fullWidth
        helperText={touched && error}
        error={touched && !!error}
      />
    </Grid>
  </Grid>
);
const renderPasswordField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <Grid container spacing={8} alignItems="flex-end">
    <Grid item xs={1} md={1} sm={1} lg={1} xl={1}>
      <img src="../../../../../assets/images/password-icon.png"/>
    </Grid>
    <Grid item xs={11} md={11} sm={11} lg={11} xl={11}>
      <TextField
        label={label}
        type="password"
        {...input}
        {...custom}
        fullWidth
        helperText={touched && error}
        error={touched && !!error}
      />
    </Grid>
  </Grid>
);

export const SignInEmailPasswordSFC: React.SFC<any> = (props: any) => {
  
  const { pristine, handleSubmit } = props;
  return (
    <div className="login-form">
      <img className="login-form-logo-img" src="../../../../../assets/images/logo.png"/>
      <h1 className="login-form-heading">Sign in to your Donaco account.</h1>
      <div className="main-div">
        <form id="login" onSubmit={handleSubmit}>
          <div style={{marginBottom: 30}}>
            <Field name="email" component={renderEmailField} label="Email Address"/>
          </div>
          <div style={{marginBottom: 50}}>
            <Field name="password" component={renderPasswordField} label="Password"/>
          </div>
          <div>
            <Button type="submit" variant="contained" className="btn btn-primary" fullWidth>
              Login
            </Button>
          </div>
        </form>
        <div className="login-form-footer">
          <div className="google-authenticate" >
            <div>
              <SignInGoogle signIn={props.signIn}/><a onClick={props.signIn}>Or authenticate with Google.</a>
            </div>
          </div>
          <Link to="/reset" className="forgot-password">Forgot password</Link>
        </div>
      </div>
    </div>
  );
};

const SignInEmailPasswordForm: any = reduxForm({
  form: 'authLogin', // a unique identifier for this form
  validate
})(SignInEmailPasswordSFC);

export default withStyles(styles)(SignInEmailPasswordForm);
